<template>
  <div>UserProfile</div>
</template>

<script>
export default {
  name: "UserProfile",
};
</script>
